<template>
	<div class="container">
		<!-- <span class="title">{{title}}</span> -->
		<span class="sub-title-home">{{subTitle}}</span>
		<img class="jietu" :src="imageUrl" />
		<span class="wechat">如有问题，请与客服联系，微信：{{wechat}}</span>
		<a class="icp" href="https://beian.miit.gov.cn/">粤ICP备2024173408号-1</a>
	</div>
</template>

<style>
	.container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.sub-title-home {
		font-size: 16px;
		color: black;
		margin-top: 24px;
		white-space: pre-wrap;
		text-align: center;
	}

	.jietu {
		width: 80vw;
		margin-top: 4px;
		margin-bottom: 12px;
	}
	.icp {
		position: fixed;
		bottom: 18px;
	}
	.wechat {
		color: #666666;
		text-align: center;
		margin-top: 12px;
	}
</style>

<script>
	import router from '../router';
	const axios = require("axios");
	
	export default {
		
		data: function() {
			return {
				title: "存图君",
				subTitle: "图片、视频一键去水印工具",
				imageUrl: "https://img.yuantujun.com/ctj-home.png",
				wechat: "cuntu456"
			}
		},
		
		mounted: function() {
			
			// let domain = window.location.hostname
			let openId = this.$route.query.openid;
			
			// console.log(domain)
			// if (domain != null && domain.indexOf("yuantujun.com") > 0) {
			// 	if (openId) {
			// 		axios
			// 		  .get("/api/member/getWebConfig?openId=" + openId)
			// 		  .then((response) => {
			// 		    console.log(response);
			// 		    let data = response.data.data;
			// 			this.title = data.title
			// 			this.subTitle = data.subTitle
			// 			this.imageUrl = data.imageUrl
			// 			// this.wechat = data.wechat
			// 		  })
			// 		  .catch((error) => {
			// 		    console.log(error);
			// 		  });
			// 	}
			// 	return
			// }
			
			if (openId) {
				this.$router.replace({
					path: '/buy',
					query: {
						openid: openId
					}
				});
			}
		},
	}
</script>